import { useEffect } from "react";
import { applyBrandTheme, resetBrandTheme } from "./brandTheme";

// Structural subset of AppearanceSettings — the misspelled field names match
// the API/DB schema and must stay as-is.
export type BrandThemeSource = {
  primayColour?: string | null;
  secondaryColour?: string | null;
} | null | undefined;

/**
 * Applies the tenant's brand colors as runtime CSS variables while mounted.
 * With no color (or no appearance at all) it does nothing, leaving the
 * default RevShare scale from index.css active.
 *
 * @param resetOnUnmount pass true on routes that must not leak the brand
 * theme when left (e.g. the public store page). Leave false where the owner
 * component remounts on navigation (BrandContext) to avoid strobing back to
 * defaults; those flows reset explicitly on logout instead.
 */
export function useBrandTheme(source: BrandThemeSource, resetOnUnmount = false): void {
  const primary = source?.primayColour || null;
  const secondary = source?.secondaryColour || null;

  useEffect(() => {
    if (primary) applyBrandTheme({ primary, secondary });
    return resetOnUnmount ? resetBrandTheme : undefined;
  }, [primary, secondary, resetOnUnmount]);
}
